var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"levo"},[_c('div',{staticClass:"levo__nazev-webu"}),_c('div',{staticClass:"scroll-container"},[_c('LevoUser'),_c('LevoBudget'),_c('LevoMenu'),_c('LevoDole'),_c('div',{staticClass:"levo__dole__ilustrace"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }